import styled from '@emotion/styled';


export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  padding: 2rem;
`;

export const UserDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
